// App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Main from './Main';
import Home from './Home';
import NotFound from './NotFound';
import Holy from './Holy';
import { isMobile } from 'react-device-detect';

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isMobile && location.pathname === '/') {
      window.location.href = 'https://piradite.nekoweb.org/home.html';
    }
  }, [location, navigate]);

  return (
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/home.php" element={<Home />} />
      <Route path='/holy.php' element={<Holy />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWrapper;
